var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComplianceUploadImage(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#D7E8FD",
    width: 108,
    height: 108,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.836 82.667H30.072c-.484 0-.893-.404-.893-.925v-4.53l1.401-1.35 17.517-16.829 8.354 5.775c.83.575 1.963.459 2.661-.279l11.74-12.362 7.877 6.304.004 23.27c0 .522-.413.926-.897.926zM30.072 20.212h31.967l.153.155v14.408c0 .55.219 1.087.603 1.475a2.08 2.08 0 0 0 1.463.608H78.44l.29.296v16l-6.788-5.429a2.055 2.055 0 0 0-2.777.192L57.339 60.37l-8.283-5.73a2.049 2.049 0 0 0-2.596.213L29.18 71.458v-50.32c0-.521.409-.926.893-.926zm36.253 4.35 8.01 8.13h-8.01v-8.13zm15.98 10.242-17.91-18.183A2.08 2.08 0 0 0 62.91 16H30.07c-2.814.004-5.067 2.313-5.071 5.137v60.605c.004 2.825 2.257 5.133 5.072 5.137h47.764c2.815-.004 5.068-2.312 5.076-5.137V36.287c0-.554-.219-1.091-.607-1.483z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.688 36.856c2.282.004 4.13 1.867 4.133 4.167-.004 2.3-1.851 4.162-4.133 4.167-2.281-.005-4.129-1.867-4.133-4.167.004-2.3 1.852-4.163 4.133-4.167m0 12.5c4.563 0 8.267-3.729 8.267-8.333s-3.704-8.333-8.267-8.333c-4.567 0-8.267 3.729-8.267 8.333s3.7 8.333 8.267 8.333"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceUploadImage);
export default __webpack_public_path__ + "static/media/compliance-upload-image.034467f7.svg";
export { ForwardRef as ReactComponent };